module.exports = __webpack_public_path__ + "img/tittle_en.add18c83.png";